module.exports = __webpack_public_path__ + "static/img/sbxt-details.76aab65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sbxt-details.png
// module id = D6HN
// module chunks = 0